import React from "react";
import { AppNotificationContext } from "../../../context/app-notification-context";
import { Notification } from "@benefit-systems/common-components";
import { useContext } from "react";

export const Notifier = () => {
  const { notificationList } = useContext(AppNotificationContext);
  return <Notification notificationList={notificationList ?? []} />;
};
